//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        lockload: [],
        searchRequest: null,
      },

      mutations: {
        updatelockload(state, list) {
          state.lockload = list;
        },
        updateSearchlockloadRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async lockload({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))
          console.log(requestToSend);

          // const validDate = requestToSend.validOn;
          // requestToSend.validOn = dateFormat.gstDateFormat(validDate);
            const st = performance.now();
            //const result = await api.post('/api/w/apar/loadlist', requestToSend);
            const result = await newAPIPost('/api/w/apar/loadlist', requestToSend);
            commit('updateSearchlockloadRequest', fallbackRequest);
            console.log(JSON.stringify(result));
            return commit('updatelockload', result);
            
                },
      },


      getters: {
        getlockload: state => state.lockload,
      },
}